import { computed, defineAsyncComponent, defineComponent } from 'vue';
export default defineComponent({
    name: 'chat-full-screen-img',
    components: {
        generalDialog: defineAsyncComponent(() => import(
        /* webpackChunkName: "Dialog" */
        'components/general/dialog.vue'))
    },
    props: {
        show: Boolean,
        fileSrc: {
            type: String,
            required: true
        }
    },
    emits: ['update:show'],
    setup(props, context) {
        const fullScreen = computed({
            get: () => props.show,
            set: (val) => {
                context.emit('update:show', val);
            }
        });
        return {
            fullScreen
        };
    }
});
